/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import {
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import Spin from "../../../components/Spin";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../../components/ui/card";
import {
  API,
  get,
  incidentMethodType,
  incidentTypeOptions,
} from "../../../config";
import { useOrganization } from "../../../lib/context/OrganisationContext";

const IncidentDetailsPopup = ({
  incidentId,
  // toggleShowModal,
  showView,
  setShowView,
}) => {
  const [incidentDetail, setIncidentDetail] = useState(null);
  const [incidentLoading, setIncidentLoading] = useState(true);
  const { organizationData } = useOrganization();

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(`${API.INCIDENT_DETAILS}/` + incidentId);
        setIncidentDetail(data.data);
        setIncidentLoading(false);
      } catch (e) {
        return null;
      }
    }
    fetchData();
  }, [incidentId, setIncidentDetail]);

  const transactionType = [
    { label: "Credit", value: "1" },
    { label: "Debit", value: "0" },
  ];

  return (
    <ResponsiveDrawerForm
      description={""}
      title={`Incident Details`}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      <>
        {incidentLoading ? (
          <Spin full expand={true} />
        ) : (
          <div className="md:p-0 p-4">
            <div className="modal-content">
              <CardTitle className="text-md mb-2">Incident Details </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>Incident Type:</strong>{" "}
                  {incidentDetail?.incident_type
                    ? incidentTypeOptions?.find(
                        (item) => item.value === incidentDetail?.incident_type,
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>Contact Type:</strong>{" "}
                  {incidentDetail?.contactable_type
                    ? incidentDetail?.contactable_type === "vendor"
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor",
                        )
                      : incidentDetail?.contactable_type === "contact"
                        ? getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer",
                          )
                        : ""
                    : ""}
                </p>
                <p>
                  <strong>
                    {incidentDetail?.contactable_type
                      ? incidentDetail?.contactable_type === "vendor"
                        ? getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "vendors",
                            "Vendor",
                          )
                        : incidentDetail?.contactable_type === "contact"
                          ? getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "contacts",
                              "Customer",
                            )
                          : ""
                      : ""}
                    :
                  </strong>{" "}
                  {incidentDetail?.contactable
                    ? formatSubcontractorName(incidentDetail?.contactable)
                    : "-"}
                </p>
                <p>
                  <strong>Review Date:</strong>{" "}
                  {incidentDetail?.review_date
                    ? incidentDetail?.review_date
                    : "-"}
                </p>
                <p>
                  <strong>Review By:</strong>{" "}
                  {incidentDetail?.review_by
                    ? formatSubcontractorName(incidentDetail?.review_by)
                    : "-"}
                </p>
                <p>
                  <strong>Verification Date:</strong>{" "}
                  {incidentDetail?.verification_date
                    ? incidentDetail?.verification_date
                    : "-"}
                </p>
                <p>
                  <strong>Verified By:</strong>{" "}
                  {incidentDetail?.verified_by
                    ? formatSubcontractorName(incidentDetail?.verified_by)
                    : "-"}
                </p>
                <p>
                  <strong>Transaction Date:</strong>{" "}
                  {incidentDetail?.transaction_date
                    ? incidentDetail?.transaction_date
                    : "-"}
                </p>
                <p>
                  <strong>Method:</strong>{" "}
                  {incidentDetail?.method
                    ? incidentMethodType?.find(
                        (item) => item.value === incidentDetail?.method,
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>Transaction Type:</strong>{" "}
                  {incidentDetail?.transaction_type
                    ? transactionType?.find(
                        (item) =>
                          item.value == incidentDetail?.transaction_type,
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>Amount:</strong>{" "}
                  {incidentDetail?.amount
                    ? formatNumber(Number(incidentDetail?.amount))
                    : "-"}
                </p>

                <p className="col-span-2">
                  <strong>Incident / Series of Events:</strong>{" "}
                  {incidentDetail?.series_of_events
                    ? incidentDetail?.series_of_events
                    : "-"}
                </p>

                <p className="col-span-2">
                  <strong>Source of the Customer Wealth:</strong>{" "}
                  {incidentDetail?.source_of_customer_wealth
                    ? incidentDetail?.source_of_customer_wealth
                    : "-"}
                </p>

                <p className="col-span-2">
                  <strong>Source of the Customer Funds:</strong>{" "}
                  {incidentDetail?.source_of_customer_funds
                    ? incidentDetail?.source_of_customer_funds
                    : "-"}
                </p>

                <p className="col-span-2">
                  <strong>Note for Austrac:</strong>{" "}
                  {incidentDetail?.note ? incidentDetail?.note : "-"}
                </p>

                {incidentDetail?.files?.length > 0 &&
                  incidentDetail?.files.map((item, index) => (
                    <p className="col-span-2">
                      <strong>Document - {index + 1}:</strong>{" "}
                      <a
                        href={item?.url}
                        download
                        target="_blank"
                        className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                        rel="noreferrer"
                      >
                        {item?.name}
                      </a>
                    </p>
                  ))}
              </div>
            </div>
          </div>
        )}
      </>
    </ResponsiveDrawerForm>
  );
};

export default IncidentDetailsPopup;
